import { render } from "./TenyearAnniversary.vue?vue&type=template&id=ee29e164"
import script from "./TenyearAnniversary.vue?vue&type=script&lang=js"
export * from "./TenyearAnniversary.vue?vue&type=script&lang=js"

import "./TenyearAnniversary.vue?vue&type=style&index=0&id=ee29e164&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__